import { Tooltip } from '@loomhq/lens';
import React, { useEffect, useState } from 'react';

import {
  HERMES_ENDPOINT,
  MESSAGE_TYPE_SUBSCRIBE,
  SUBSCRIPTION_TYPE_TRIM_PROGRESS,
} from 'constants/hermes';
import {
  DOWNLOAD_DISABLED_TEXT,
  DOWNLOAD_DISABLED_TOOLTIP,
} from 'constants/menuOptions';
import { LOOM_WS_URI } from 'constants/routes';
import Websocket from 'utilities/websocket';

export const TrimProgressTooltip = ({ videoId, onComplete }) => {
  const MAX_CONNECTION_RETRIES = 5;
  const connectionAttempts = 0;

  const [progress, setProgress] = useState(null);
  const canDisplayProgress = typeof progress === 'number' && progress < 100;

  let websocket;

  // Ensure websocket is closed on unmount
  useEffect(() => {
    setupWs();

    return function cleanup() {
      websocket && websocket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tooltip
      content={DOWNLOAD_DISABLED_TOOLTIP}
      placement="leftCenter"
      triggerOffset={38}
      maxWidth={32}
    >
      <span>{DOWNLOAD_DISABLED_TEXT}</span>
      {canDisplayProgress && (
        <span style={{ fontFeatureSettings: 'tnum' }}>{` (${progress}%)`}</span>
      )}
    </Tooltip>
  );

  function setupWs() {
    websocket = new Websocket(LOOM_WS_URI + HERMES_ENDPOINT);

    websocket.ready(() => {
      websocket.send(
        JSON.stringify({
          type: MESSAGE_TYPE_SUBSCRIBE,
          subscription_data: {
            type: SUBSCRIPTION_TYPE_TRIM_PROGRESS,
            video_id: videoId,
          },
        })
      );

      websocket.onMessage(({ data }) => {
        const message = JSON.parse(data);
        const progress = Math.floor(Number(message.progress));

        // Prevent 99.X from being rounded to 100%, it might seem like a bug to users
        // |progress| should never exceed 100%
        setProgress(progress);

        if (progress === 100) {
          onComplete && onComplete();
        }
      });

      websocket.onError(() => {
        retryWithDelay();
      });
    });

    function retryWithDelay() {
      if (connectionAttempts >= MAX_CONNECTION_RETRIES) {
        // give up
        return;
      }

      window.setTimeout(() => {
        setupWs();
      }, 2000 * Math.pow(2, Math.max(connectionAttempts, 4)));
    }
  }
};
